import uniqueId from 'lodash/uniqueId';
import { Header, Modal, Button } from 'semantic-ui-react';

export const showModal = (options) => (dispatch) => new Promise((res, rej) => {
  const modalId = uniqueId();

  const onClose = (err, result) => {
    if (err) {
      rej(err);
    } else {
      res(result);
    }

    dispatch({ type: 'DESTROY_MODAL', id: modalId });
  };

  dispatch({
    type: 'SHOW_MODAL', id: modalId, onClose, options,
  });
});

export const showError = ({ content, header = 'Operation failed', size = 'tiny' }) => showModal({
  body: (
    <>
      <Header icon='close' content={header} />
      <Modal.Content>
        {content}
      </Modal.Content>
    </>
  ),
  size,
  actions: { accept: <Button negative content='Okay' /> },
});
